import { FC } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import styles from './TaskCard.module.scss';
import Badge from '../Badge/Badge';
import appState from '../../../state/AppStateContainer';
import BtButton from '../../../ts-components/bt-button/bt-button';

interface TaskCardProps extends RouteComponentProps {
  title: string;
  description: string;
  isCompleted: boolean;
  buttonText: string;
  note?: string;
  icon: React.ComponentType;
  redirectTo?: string;
  onButtonClick?: () => void;
}

const TaskCard: FC<TaskCardProps> = ({
  title,
  description,
  isCompleted,
  buttonText,
  note,
  icon: Icon,
  redirectTo,
  onButtonClick,
  history
}) => {

  const handleButtonClick = () => {
    if (onButtonClick) {
      onButtonClick();
    } else if (redirectTo) {
      const orgSlug = appState.getCurrentOrgSlug();
      history.push(`/${orgSlug}${redirectTo}`);
    }
  };
  const getStatusText = () => {
    return isCompleted ? 'KLAR' : 'EJ KLAR';
  };

  return (
    <div className={styles.taskCard}>
      <div className={styles.taskContent}>
        <div className={`${styles.taskIcon} ${isCompleted ? styles.taskIconCompleted : ''}`}>
          <Icon />
        </div>
        <div className={styles.taskRightSection}>
          <div className={styles.taskInfo}>
            <div className={styles.taskHeader}>
              <h3 className={styles.taskTitle}>{title}</h3>
              {!isCompleted && (
                <Badge 
                  className={styles.statusBadge}
                >
                  {getStatusText()}
                </Badge>
              )}
            </div>
            <p className={styles.taskDescription}>{description}</p>
          </div>
          {!isCompleted && (note ? (
            <p className={styles.taskNote}>{note}</p>
          ) : (
            <div className={styles.taskButtonContainer}>
              <BtButton 
                onClick={handleButtonClick}
                color=""
                size="base"
              >
                {buttonText}
              </BtButton>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default withRouter(TaskCard);
